import { CollectibleType } from "../../../models/collectible";

export const Title = (collectableType: CollectibleType, title: string) => {
  return collectableType === "Podcast" ? `Episode - ${title}` : title;
};
